<template>
  <div>
    <el-card>
      <!--基础信息-->
      <div style="font-size: 14px; color: #606266;">
        <span>No：{{ formData.custNo }}</span>
        <el-divider direction="vertical"></el-divider>
        <span>Status：{{ formData.custStatusText }}</span>
        <el-divider direction="vertical"></el-divider>
        <span
          >Create：{{ formData.createByName }} at
          {{ formData.createDate }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span
          >Modify：{{ formData.modifyByName }} at
          {{ formData.modifyDate }}</span
        >
      </div>
      <div class="d2-mt">
        <el-form ref="formData" :model="formData" :rules="rules" size="mini">
          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 12 }" :lg="{ span: 12 }">
              <el-form-item
                :label="$l('table_label_customerName') || '客户名称'"
                prop="custName"
              >
                <el-input
                  :disabled="disabled || diversityFlag"
                  v-model="formData.custName"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="200"
                  show-word-limit
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_customerType') || '客户类型'"
                prop="customerType"
              >
                <dict-select
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  :disabled="disabled"
                  clearable
                  filterable
                  v-model="formData.customerType"
                  size="mini"
                  url="/digitalCenter/common/dict/biz"
                  :body="{ dictType: 'customerType' }"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_storeType') || '门店类型'"
                prop="storeType"
              >
                <dict-select
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  :disabled="disabled"
                  clearable
                  filterable
                  v-model="formData.storeType"
                  size="mini"
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'storeType' }"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_customer Definition') || '客户定义'"
                prop="customerDefinition"
              >
                <dict-select
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  :disabled="disabled"
                  clearable
                  filterable
                  v-model="formData.customerDefinition"
                  size="mini"
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'customerDefinition' }"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="
                  $l('form_label_customer_classification') || '客户基本分类'
                "
                prop="marketRegion"
              >
                <dict-select
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  :disabled="disabled"
                  clearable
                  filterable
                  v-model="formData.marketRegion"
                  size="mini"
                  url="/digitalCenter/common/dict/biz"
                  :body="{ dictType: 'marketRegion' }"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 12 }" :lg="{ span: 12 }">
              <el-form-item
                :label="$l('table_label_detailedAddress') || '详细地址'"
                prop="custAddress"
              >
                <el-input
                  :disabled="disabled || diversityFlag"
                  v-model="formData.custAddress"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="500"
                  show-word-limit
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_primaryContact') || '主要联系人'"
                prop="contact"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contact"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="50"
                  show-word-limit
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_cellPhone') || '联系人手机'"
                prop="contactMobile"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactMobile"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="50"
                  clearable
                  show-word-limit
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_fixedTelephone') || '固定电话'"
                prop="contactPhone"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactPhone"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="50"
                  show-word-limit
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_email') || 'Email'"
                prop="contactEmail"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactEmail"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="50"
                  show-word-limit
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_contactJob') || '联系人职务'"
                prop="contactJob"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactJob"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="50"
                  show-word-limit
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="$l('table_label_customer_brand') || '客户品牌'"
                prop="brandCodeList"
              >
                <dict-select
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  size="mini"
                  clearable
                  multiple
                  filterable
                  :disabled="disabled"
                  v-model="formData.brandCodeList"
                  url="/digitalCenter/masterbrand/masterBrandSelect"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 12 }" :lg="{ span: 12 }">
              <el-form-item
                :label="$l('form_label_paymentTerms') || '付款条件'"
              >
                <dict-select
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  size="mini"
                  clearable
                  filterable
                  :disabled="disabled"
                  v-model="formData.paymentTerms"
                  url="/master/common/dict/biz"
                  :body="paymentTermsParams"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :sm="{ span: 20 }" :md="{ span: 6 }" :lg="{ span: 6 }">
              <el-form-item
                :label="
                  $l('table_label_business_license') || '统一社会信用代码'
                "
                prop="businessLicense"
              >
                <el-input
                  :disabled="disabled || diversityFlag"
                  v-model="formData.businessLicense"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="50"
                  show-word-limit
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 18 }" :lg="{ span: 18 }">
              <el-form-item
                :label="$l('table_label_consumerGroups') || '消费人群'"
                prop="endCustomers"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.endCustomers"
                  maxlength="200"
                  show-word-limit
                  clearable
                  size="mini"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_custProductCategory') || '客户产品品类'"
              >
                <el-input
                  v-model="formData.custProductCategory"
                  type="textarea"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  rows="3"
                  maxlength="500"
                  show-word-limit
                  :disabled="disabled"
                  size="mini"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <CustomerBankTable
              :disabled="disabled || diversityFlag"
              :custCode="formData.custCode"
              ref="custBank"
            />
          </el-row>
        </el-form>
        <div class="d2-mt" v-show="false">
          <div class="side-frame">
            {{ $l('tips_customerOptions') || '客户选项' }}
          </div>
          <labels ref="labels" :disabled="disabled" :params="params" />
        </div>
        <!--按钮-->
        <div class="d2-mt">
          <el-row>
            <el-col :span="20">
              <el-button
                @click="saveData"
                v-if="!disabled"
                size="mini"
                type="primary"
              >
                {{ $l('btn_save') || '保存' }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import Labels from '../labels'
import CustomerBankTable from '../customer-bank-table/table'
// import { mapActions } from 'vuex'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {
    Labels,
    CustomerBankTable,
  },
  data() {
    return {
      pageHeader: '',
      dialogVisible: false,
      disabled: false,
      provinceOptions: [], //  省份
      cityOptions: [], //  市
      districtOptions: [], //  县
      cityVaild: true,
      districtValid: true,
      diversityFlag: false, //控制变更的三个字段禁用属性
      params: {
        custCode: '',
      },
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      paymentTermsParams: { dictType: 'paymentTerms' },
      formData: {
        custCode: '',
        custNo: '',
        custName: '',
        regionCode: '100000',
        regionName: '中国',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        custAddress: '',
        contact: '',
        contactMobile: '',
        contactPhone: '',
        contactEmail: '',
        contactJob: '',
        companyCode: '',
        custStatus: '',
        createBy: '',
        createDate: '',
        modifyBy: '',
        modifyDate: '',
        createByName: '',
        modifyByName: '',
        customerType: '',
        storeType: '',
        customerDefinition: '',
        marketRegion: '',
        endCustomers: '',
        businessLicense: '',
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        bankAccountKind: '',
        brandCodeList: [],
      },
      rules: {
        custName: [
          {
            required: true,
            message: this.$l('form_rule_customer_name') || '请输入客户名称',
            trigger: 'blur',
          },
          {
            max: 200,
            message:
              this.$l('form_rule_input_length_200') || '长度在200个字符以内',
            trigger: 'blur',
          },
        ],
        customerType: [
          {
            required: true,
            message:
              this.$l('form_label_select_customerType') || '请选择客户类型',
            trigger: 'change',
          },
        ],
        marketRegion: [
          {
            required: true,
            message:
              this.$l('form_label_select_customer_classification') ||
              '请选择客户基本分类',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.params.custCode) {
      let type = this.$route.params.pageType
      let custCode = this.$route.params.custCode
      this.init(type, custCode)
    }
  },
  activated() {
    if (this.$route.params.custCode) {
      let type = this.$route.params.pageType
      let custCode = this.$route.params.custCode
      this.init(type, custCode)
    }
  },
  methods: {
    // ...mapActions('admin/page', ['close']),
    init(type, custCode) {
      this.resetData()
      if (type === 'edit') {
        this.params.custCode = custCode
        this.updateLoad(custCode)
      } else if (type === 'detail') {
        this.params.custCode = custCode
        this.detailLoad(custCode)
      } else if (type === 'add') {
        this.addLoad()
      }
    },
    addLoad() {
      this.pageHeader = this.$l('page_add') || '客户档案信息新增'
      if (this.$refs.formData) {
        this.$refs.formData.resetFields()
      }
      // this.loadProvinceOptions()
    },
    updateLoad(val) {
      this.pageHeader = this.$l('page_edit') || '客户档案信息修改'
      this.disabled = false
      let param = { custCode: val }
      this.$api.custInfoDetailApi(param).then((res) => {
        this.formData = res.body
        this.diversityFlag = this.formData.custStatus == 'Y'
        this.$refs.labels.load(param)
      })
    },
    detailLoad(val) {
      this.pageHeader = this.$l('page_detail') || '客户档案信息详情'
      this.disabled = true
      let param = { custCode: val }
      this.$api.custInfoDetailApi(param).then((res) => {
        this.formData = res.body
        this.$refs.labels.load(param)
      })
    },
    // 保存数据
    saveData() {
      this.formData.regionCode = '100000'
      this.formData.regionName = '中国'
      const form = this.$refs.formData
      validate.formValidate([form], (valid) => {
        if (valid) {
          this.loadingOpen()
          this.$api
            .custInfoSaveApi(this.formData)
            .then((res) => {
              this.formData.custCode = res.body
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || '保存成功',
                type: 'success',
              })
              if (this.formData.custCode) {
                this.$router.replace({
                  name: 'customerManage-info-edit',
                  params: { custCode: res.body, pageType: 'edit' },
                })
              }
              this.loadingClose()
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    // 省份下拉
    loadProvinceOptions() {
      let regionDictParam = { levelType: '1', parentId: '0' }
      // 省份下拉
      this.$api
        .baseRegion(regionDictParam)
        .then((res) => {
          this.provinceOptions = res.body.data
          this.loadCityOptions()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 市级下拉
    loadCityOptions() {
      let regionDictParam = {
        levelType: '2',
        parentId: this.formData.provinceCode,
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.cityOptions = res.body.data
          if (this.cityVaild === false) {
            this.formData.cityCode = ''
            this.formData.districtCode = ''
          }
          this.loadDistrictOptions()
          this.cityVaild = false
        })
      } else {
        this.formData.cityCode = ''
        this.formData.districtCode = ''
        this.cityOptions = []
        this.districtOptions = []
      }
    },
    // 县级下拉
    loadDistrictOptions() {
      let regionDictParam = { levelType: '3', parentId: this.formData.cityCode }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.districtOptions = res.body.data
          if (this.districtValid === false) {
            this.formData.districtCode = ''
          }
          this.districtValid = false
        })
      } else {
        this.formData.districtCode = ''
        this.districtOptions = []
      }
    },
    // 重置表单数据
    resetData() {
      this.formData = {
        custCode: '',
        custNo: '',
        custName: '',
        regionCode: '100000',
        regionName: '中国',
      }
      this.cityVaild = true
      this.districtValid = true
      this.dialogVisible = false
      this.disabled = false
      this.pageHeader = ''
      this.provinceOptions = [] //  省份
      this.cityOptions = [] //  市
      this.districtOptions = [] //  县
      this.$refs.formData.resetFields()
    },
    // saveOkQuestion() {
    //   this.$alert(
    //     this.$l('INDEX.tips_save_ok') || '保存成功',
    //     this.$l('INDEX.tips_question_title') || '提示信息',
    //     {
    //       confirmButtonText: '确定',
    //       callback: () => {
    //         this.closeCurPage()
    //       },
    //     }
    //   )
    // },
    // async closeCurPage() {
    //   // 关闭当前页面
    //   await this.close({
    //     tagName: this.$route.fullPath,
    //     showConfirm: false,
    //   })
    // },
  },
}
</script>
<style lang="scss" scoped>
// .side-frame {
//   padding: 1px 10px;
//   border-left: 3px solid $color-primary;
//   margin: 15px 0;
// }
// .text-annotation {
//   color: $color-primary;
//   font-size: 13px;
// }
// .avatar-uploader {
//   i {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
//     &:hover {
//       border-color: #409eff;
//     }
//   }
// }
// .icon-right {
//   font-size: 28px;
//   color: #8c939d;
//   width: 300px;
//   height: 200px;
//   line-height: 200px !important;
//   text-align: center;
// }
// .events-uploader-icon {
//   font-size: 28px;
//   color: #8c939d;
//   width: 300px !important;
//   height: 200px;
//   line-height: 200px !important;
//   text-align: center;
// }
// .events-uploader-icon-mini {
//   font-size: 28px;
//   color: #8c939d;
//   width: 120px !important;
//   height: 80px;
//   line-height: 80px !important;
//   text-align: center;
// }
// .events {
//   width: 300px !important;
//   height: 200px;
//   display: block;
// }
// .el-tag + .el-tag {
//   margin-left: 10px;
// }
// .button-new-tag {
//   margin-left: 10px;
//   height: 32px;
//   line-height: 30px;
//   padding-top: 0;
//   padding-bottom: 0;
// }
// .input-new-tag {
//   width: 90px;
//   margin-left: 10px;
//   vertical-align: bottom;
// }
</style>
